<template>
        <v-progress-circular
            class="d-flex mx-auto"
            indeterminate
            size="50"
            color="primary"
        >
        </v-progress-circular>
</template>

<script>
export default {
    name: "loader",
};
</script>
